import { Typography, useTheme } from "@mui/joy";
import React from "react";
import { Util } from "./Helpers/Util";

export default function Header() {
	const theme = useTheme();
	const [first, setFirst] = React.useState("");
	const [last, setLast] = React.useState("");
	React.useEffect(() => {
		getUserInfo();
	}, []);

	const getUserInfo = () => {
		fetch("/User/GetPersonInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((y) => {
				setFirst(y.first_name);
				setLast(y.last_name);
				Util.CurrentRole = y.role;
			});
	};

	let fullName = first;
	if (!Util.isNullOrEmpty(last)) {
		fullName = fullName + " " + last.substring(0, 1) + ".";
	}

	return (
		<div style={{ height: "30px", borderBottom: theme.palette.background.level2, paddingBottom: theme.spacing(1) }}>
			<Typography level="title-md" sx={{ float: "right" }}>
				Welcome, {fullName}
			</Typography>
		</div>
	);
}
